import { EditOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import styled from 'styled-components';
import { Body, H5 } from '../../styles/fonts';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100vh;
  min-height: 100vh;
`;

export const Sidebar = styled.div`
  width: 180px;
  min-width: 180px;
  max-width: 180px;
  flex-shrink: 0;
  border-right: 1px solid #ececec;
  padding: 32px 0 0 0;
  background: #fff;
  height: 100%;
`;

export const SidebarItem = styled.div<{ active?: boolean }>`
  padding: 8px 24px;
  cursor: pointer;
  color: ${({ active, theme }) => (active ? theme.colors.primary[6] : '#222')};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  border-left: ${({ active, theme }) =>
    active ? `3px solid ${theme.colors.primary[6]}` : '3px solid transparent'};
  background: ${({ active }) => (active ? '#faf6ff' : 'transparent')};
`;

export const Content = styled.div`
  flex: 1;
  width: calc(100% - 180px);
  min-width: 0;
  height: 100%;
  padding: 48px 0 0 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow-x: auto;
  background: #f8f9fa;
`;

export const SectionTitle = styled(H5)`
  margin-left: 120px;
  margin-bottom: 8px;
  color: #3a4a5b;
`;

export const Section = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 32px;
`;

export const CenterBox = styled.div`
  width: calc(100% - 240px);
  max-width: 1200px;
  min-width: 600px;
  margin-left: 120px;
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 6px;
  padding: 0;
`;

export const Table = styled.div`
  width: 100%;
`;

export const TableRow = styled.div`
  display: flex;
  align-items: center;
  border-bottom: 1px solid #ececec;
  padding: 0 24px;
  min-height: 48px;
  &:last-child {
    border-bottom: none;
  }
`;

export const TableCellTitle = styled(Body)`
  flex: 0 0 180px;
  font-weight: bold;
  color: #3a4a5b;
`;

export const TableCell = styled(Body)`
  flex: 1;
  color: #3a4a5b;
`;

export const EditIcon = styled(EditOutlined)`
  margin-left: 8px;
  color: #bdbdbd;
  cursor: pointer;
`;

// Componentes específicos para a tela de Consumo
export const MonthSelector = styled(Select)`
  width: 200px;
  margin-bottom: 32px;
`;

export const ConsumptionCard = styled.div`
  background: #fff;
  border: 1px solid #ececec;
  border-radius: 8px;
  padding: 24px;
  margin-bottom: 32px;
  position: relative;
`;

export const ConsumptionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
`;

export const ConsumptionTitle = styled(Body)`
  font-weight: bold;
  color: #2c3e50;
  font-size: 18px;
  margin-bottom: 0;
`;

export const ConsumptionSubtitle = styled(Body)`
  color: #7f8c8d;
  font-size: 13px;
  font-weight: 400;
  margin-top: 0;
`;

export const TotalValue = styled.div`
  text-align: right;
`;

export const TotalAmount = styled.div`
  font-size: 24px;
  font-weight: bold;
  color: #3a4a5b;
`;

export const TotalLabel = styled(Body)`
  color: #888;
  font-size: 12px;
`;

export const WalletIcon = styled.img`
  width: 40px;
  height: 40px;
  margin-left: 16px;
`;

export const ProgressSection = styled.div`
  margin-bottom: 16px;
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 8px;
  background: #f0f0f0;
  border-radius: 4px;
  overflow: hidden;
  margin: 8px 0;
`;

export const ProgressFill = styled.div<{ width: number }>`
  width: ${props => props.width}%;
  height: 100%;
  background: #391085;
`;

export const ProgressText = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
`;

export const TotalToPay = styled(Body)`
  color: #391085;
  font-weight: bold;
  cursor: pointer;
  text-decoration: underline;
`;

export const PricingTable = styled.div`
  margin-top: 32px;
`;

export const PricingTableHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr;
  gap: 16px;
  padding: 16px 0;
  border-bottom: 2px solid #ececec;
`;

export const PricingTableRow = styled.div<{ highlighted?: boolean }>`
  display: grid;
  grid-template-columns: 1fr 2fr 2fr 2fr;
  gap: 16px;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  background: ${props => (props.highlighted ? '#f0f7ff' : 'transparent')};
`;

export const PricingHeaderCell = styled(Body)`
  font-weight: bold;
  color: #6c5ce7;
`;

export const PricingCell = styled(Body)`
  color: #3a4a5b;
`;

export const HighlightText = styled.span`
  background: #fff3cd;
  padding: 2px 4px;
  border-radius: 3px;
`;
